import { ref } from '@vue/composition-api'

/**
 * Reactive chart color version counter
 * Increment this when colors change to trigger re-renders in components that watch it
 */
export const chartColorVersion = ref(0)

/**
 * Increment the chart color version to trigger re-renders
 * Call this after saving new colors to localStorage
 */
export function notifyChartColorsChanged () {
	chartColorVersion.value++
}
